import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=3e167d62&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=3e167d62&prod&lang=scss&scoped=true"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=3e167d62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e167d62",
  null
  
)

export default component.exports